/**
 * Agent Detail scope — carries the agent currently open in the detail screen so
 * `useAgentDetail()` can derive per-agent content without every tab having to
 * thread the pk down. The provider wraps the tab area; `useAgentDetail()` reads
 * this to pick which agent's derived detail to return.
 */
import { createContext, useContext } from 'react';
import type { AgentScope } from '../viewmodels/agent_detail_derive.js';

const Ctx = createContext<AgentScope | null>(null);

export const AgentDetailScopeProvider = Ctx.Provider;

export function useAgentDetailScope(): AgentScope | null {
  return useContext(Ctx);
}
